export enum MCFormType {
  MC_NUMBER = 'mcNumber',
  NO_NUMBER = 'noNumber',
}
